<template>
    <div id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title"> Assign Playlist </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark color="white">fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <div id="slideout-container">
            <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
                <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">Select Users</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="e1 > 2" step="2">Select Playlist</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="max-height-list scroll-y">
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-text-field
                            v-model="userSearch"
                            label="Filter Users By Name"
                            type="text"
                            @change="applyUserSearch"
                            class="filter-user"
                            append-icon="fa-search"
                            ></v-text-field>
                            <v-expansion-panels accordion 
                            v-model="panel"
                            multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Select Users</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-skeleton-loader v-if="userLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                                        <v-skeleton-loader v-if="userLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                                        <v-data-table
                                        v-model="selectedUsers"
                                        :headers="userHeaders"
                                        :options.sync="userOptions"
                                        :server-items-length="serverUserItemsLength"
                                        v-show="!userLoading"
                                        :items="users"
                                        item-key="id"
                                        show-select
                                        class="enrol-user-list-tbl"
                                        :items-per-page="5"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>              
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="max-height-list scroll-y">
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-text-field
                            v-model="channelSearch"
                            label="Filter Channel By Name"
                            type="text"
                            @change="applyChannelSearch"
                            class="filter-user"
                            append-icon="fa-search"
                            ></v-text-field>
                            <v-expansion-panels accordion 
                            v-model="panel"
                            multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Select Channel</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-skeleton-loader v-if="channelLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                                        <v-skeleton-loader v-if="channelLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                                        <v-data-table
                                        v-model="selectedChannels"
                                        :headers="channelHeaders"
                                        :options.sync="channelOptions"
                                        :server-items-length="serverChannelItemsLength"
                                        v-show="!channelLoading"
                                        :items="channels"
                                        item-key="id"
                                        show-select
                                        class="enrol-user-list-tbl"
                                        :items-per-page="5"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>              
                        </div>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
        <v-footer absolute height="68">
            <v-flex px-4 py-4 text-right>
                <div v-if="e1 == 1">
                    <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
                    <v-btn color="primary" class="add-course-button" @click="e1 = 2">Next</v-btn>
                </div>
                <div v-if="e1 == 2">
                    <v-btn v-if="!loading" color="grey300" class="mr-4" @click="e1 = 1">Back</v-btn>
                    <v-btn v-if="loading" color="primary" loading></v-btn>
                    <v-btn v-else color="primary" class="add-course-button" @click="processChannels">Save</v-btn>
                </div>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import channelAPI from "@/api/channel.js";
    import userAPI from "@/api/user.js";
    import { EventBus } from "@/event-bus.js";
    export default {
        name: "UserDetails",
        props: {
            params: {
                type: String,
                default: ""
            },
            elm: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                e1: this.elm ? this.elm : 1,
                userHeaders: [
                    { text: "First Name", value: "first_name" },
                    { text: "Surname", value: "last_name" },
                    { text: "Email", value: "email" }
                ],
                channelHeaders: [
                    { text: "Playlist", value: "name" },
                ],
                panel: [0,1],
                loading: false,
                selectedUsers: [],
                selectedChannels: [],
                userSearch: "",
                channelSearch: "",
                users: [],
                channels: [],
                userSearchParams: "",
                channelSearchParams: "",
                userOptions: {},
                channelOptions: {},
                userLoading: false,
                channelLoading: false,
                userPagination: {},
                channelPagination: {},
                successMessage: "Playlist Successfully enrolled",
                errorMessage:
                    "Oops, something went wrong! Please check information is correct.",
            };
        },
        computed: {
            serverUserItemsLength: function() {
                return this.userPagination.total;
            },
            userParams: function() {
                return this.$gf.getQueryString(this.userOptions, this.serverUserItemsLength);
            },
            serverChannelItemsLength: function() {
                return this.channelPagination.total;
            },
            channelParams: function() {
                return this.$gf.getQueryString(this.channelOptions, this.serverChannelItemsLength);
            },
            isTabletOrDesktop() {
                const width = this.$vuetify.breakpoint.width;
                return width >= 820;
            },
        },
        watch: {
            userOptions: {
                handler() {
                    this.getEnrolledUsers();
                },
                deep: true
            },
            channelOptions: {
                handler() {
                    this.getallChannels();
                },
                deep: true
            }
        },
        methods: {
            getEnrolledUsers() {
                this.userLoading = true;
                userAPI
                .getManagerTeams(
                    this.userParams+
                    this.userSearchParams
                    )
                .then(resp => {
                    this.users = resp.data.data;
                    this.userPagination = resp.data.meta.pagination;
                    this.userLoading = false;
                });
            },
            getallChannels() {
                this.channelLoading = true;
                channelAPI
                .getChannels(
                    this.channelParams+
                    this.channelSearchParams
                    )
                .then(resp => {
                    this.channels = resp.data.data;
                    this.channelPagination = resp.data.meta.pagination;
                    this.channelLoading = false;
                });
            },
            applyUserSearch() {
                this.userOptions.page = 1;
                if (this.userSearch != null) {
                    this.userSearchParams =
                    this.userParams + "&search=first_name:" + this.userSearch + ";last_name:" + this.userSearch;
                } else {
                    this.userSearchParams = this.userParams;
                }
                this.getEnrolledUsers();
            },
            applyChannelSearch() {
                this.channelOptions.page = 1;
                if (this.channelSearch != null) {
                    this.channelSearchParams =
                    this.channelParams +
                    "&search=name:" +
                    this.channelSearch;
                } else {
                    this.channelSearchParams = this.channelParams;
                }
                this.getallChannels();
            },
            closePanel() {
                this.$emit("closePanel", {});
            },
            processSelectedUsers() {

                let users = [];
                this.selectedUsers.forEach(function(x) {
                    users.push(x.id);
                });
                return users;
            },
            processSelectedChannel() {

                let channels = [];
                this.selectedChannels.forEach(function(x) {
                    channels.push(x.id);
                });
                return channels;
            },
            processChannels() {
                this.loading = true;
                channelAPI
                .enrolStaffChannel({
                    assign_users: this.processSelectedUsers(),
                    assign_playlists: this.processSelectedChannel()
                })
                .then(() => {
                    this.closePanel();
                    this.$snotify.success(this.successMessage);
                    this.loading = false;
                    EventBus.$emit("TEAM_COURSES_UPDATED");
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                })
                .catch(() => {
                    this.$snotify.error(this.errorMessage);
                    this.loading = false;
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                });
            }
         
        }
    };
</script>
<style media="screen">
#slideout-container {
    height: calc(100vh - 65px - 100px);
}
.max-height-list {
    height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
    transition: none;
}
</style>
